module.exports = __webpack_public_path__ + "static/trusted-8e8807efede95461c8b46b717c3ef52a.png";